import axios from "axios";

const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cw_portal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/portal/login") && !window.location.pathname.startsWith("/portal/accept") && !window.location.pathname.startsWith("/portal/forgot") && !window.location.pathname.startsWith("/portal/reset")) {
      localStorage.removeItem("cw_portal_token");
      window.location.href = "/portal/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};

export default portalApi;
